import { createSelector } from '@reduxjs/toolkit';

import { License, LicenseMode } from '@/domain/auth/entities/user.entity.ts';
import { RootState } from '@/domain/store';

export const selectIsAuthenticated = (state: RootState) => {
  return state.auth.isAuthenticated;
};

export const selectUserLicenses = (state: RootState) => {
  return state.auth.userInfos.licenses;
};

export const selectUserLicensesMap = createSelector(
  [selectUserLicenses],
  (userLicenses) => {
    const licenseMap = new Map<LicenseMode, License>();
    for (const license of userLicenses) {
      licenseMap.set(license.mode, license);
    }
    return licenseMap;
  },
);

export const selectUserTrial = (state: RootState) => {
  return state.auth.userInfos.trial;
};

export const selectUserFullname = (state: RootState) => {
  const { firstname, lastname } = state.auth.userInfos;
  const fullname = `${firstname} ${lastname}`;
  return fullname;
};
